module.exports = __webpack_public_path__ + "static/img/beianbgs.a1ba0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beianbgs.png
// module id = NpKf
// module chunks = 1